module.exports = __webpack_public_path__ + "static/media/login.0a308871.png";